import classNames from "classnames";
import React from "react";

import { ButtonBase, ButtonProps } from "./ButtonBase";

type ButtonVariant = "default" | "cta";
type DefaultButtonSize = "default" | "large" | "small";
type DefaultButtonColor = "default" | "contrast" | "danger" | "outline";

export interface DefaultButtonProps extends ButtonProps {
  /** Toggles between the default and modified variants of button such as the CTA button*/
  buttonVariant?: ButtonVariant;
  /** Used to make buttons larger or smaller than their default size*/
  buttonSize?: DefaultButtonSize;
  /** Changes button background, text, and border colours*/
  buttonColor?: DefaultButtonColor;
  /** Additional classes to add to the button */
  extraClasses?: string;
}

export const Button: React.FC<DefaultButtonProps> = ({
  buttonVariant = "default",
  buttonSize = "default",
  buttonColor = "default",
  extraClasses,
  children,
  ...props
}) => {
  const buttonClasses = classNames("button", {
    [`button-${buttonVariant}`]: buttonVariant !== "default",
    [`button--${buttonColor}`]: buttonColor !== "default",
    [`button--${buttonSize}`]: buttonSize !== "default",
    [`${extraClasses}`]: extraClasses,
  });

  return (
    <ButtonBase {...props} buttonClasses={buttonClasses}>
      {children}
    </ButtonBase>
  );
};
